<template>
    <div class="col-md-4 col-sm-4 col-md-offset4 col-sm-offset4">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4>{{ $t('need_login') }}</h4>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <input type="text" class="form-control" v-model="username" :placeholder="$t('username')">
                </div>
                <div class="form-group">
                    <input type="password" class="form-control" v-model="password" :placeholder="$t('password')">
                </div>
                <input type="submit" class="btn btn-lg btn-success btn-block" @click="login" :value="$t('login')">
            </div>
        </div>
        <div>
            <p>{{ $t('text_tip') }} </p>
            <p>{{ $t('more_info_url') }}</p>
            <p><a href="http://www.hipercom.es" target="_blank"> http://www.hipercom.es</a></p>
            <p><a href="http://www.tpaas.es" target="_blank"> http://www.tpaas.es</a></p>

            <p>{{ $t('contract') }}</p>
            <p><a href="http://www.tpaas.es/contratacion" target="_blank"> http://www.tpaas.es/contratacion</a></p>
        </div>
    </div>
</template>

<script>

import tpaas from '../helpers/tpaas.js'
import addinConfig from '../helpers/addin-config.js';

export default {
    name: 'Login',
    data: function () {
        return  {
            username: '',
            password: '',
        }
    },
    methods: {
        login: function () {
            var self = this;
            tpaas.doLogin(this.username, this.password, this.$root.$i18n.locale)
            .then(function (data) {
                if (data.result == 'ok') {
                    addinConfig.setConfig({ username: self.username, password: self.password});
                    self.$emit('logged', data, self.username, self.password);
                }
            })
            .catch(function (message) {
                if (message != '')
                    self.$emit('loginerror', message);
            });
        }
    }
}
</script>

<style src="bootstrap/dist/css/bootstrap.min.css"></style>

<style>
.btn-success, .btn-success:focus {
    background-color: #197c9f;
    border-color: #0c5b77;
}

.btn-success:hover, .btn-success:active, .btn-success:active:focus, .btn-success:hover:focus {
    background-color: #0b3b4d;
    border-color: #0c5b77;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue